import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../context/CreatorContext";

const ShowcaseEmptyState = ({
	title,
	subtitle,
	buttonText,
	image,
	borderRadius,
}) => {
	const { creator } = useContext(CreatorContext);
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				padding: 2,
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
				backgroundColor: creator.themeColor,
				color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
				borderBottomLeftRadius: borderRadius ? "26px" : 0,
				borderBottomRightRadius: borderRadius ? "26px" : 0,
			}}
		>
			{image && (
				<img
					src={image}
					alt="empty state"
					style={{ width: "100px", height: "auto", objectFit: "cover" }}
				/>
			)}
			<Typography
				variant="body2"
				sx={{
					marginBottom: 1,
					marginTop: 1,
					fontSize: "8px",
					textAlign: "center",
				}}
			>
				{title}
			</Typography>
			{subtitle && (
				<Typography
					variant="body2"
					sx={{ marginBottom: 1, fontSize: "8px", textAlign: "center" }}
				>
					{subtitle}
				</Typography>
			)}

			<Button
				variant="contained"
				fullWidth
				sx={{
					backgroundColor: creator ? creator.color : "#45A049",
					"&:hover": {
						backgroundColor: creator ? creator.color : "#45A049",
					},
					color: creator && creator.whiteTextButton ? "#ffffff" : "#000000",
					fontSize: "8px",
					borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
					fontWeight: "bold",
					textTransform: "uppercase",
					height: "28px",
					width: "100%",
				}}
			>
				{buttonText}
			</Button>
		</Box>
	);
};

export default ShowcaseEmptyState;
